import {
  __export
} from "./chunk-5VRACIDE.mjs";

// src/StringUtils/index.ts
var StringUtils_exports = {};
__export(StringUtils_exports, {
  DWORDHexString: () => DWORDHexString,
  HexString: () => HexString,
  Utf16: () => Utf16,
  Utf8: () => Utf8
});
import { Utf8, Utf16, HexString } from "utf-helpers";
var DWORDHexString = {
  _checkU32: (num) => {
    if (typeof num !== "number")
      throw new Error(`Passed number is not a number: ${typeof num}, ${num}`);
    if (isNaN(num))
      throw new Error(`Passed number is NaN: ${num}`);
    if (num < 0)
      throw new Error(`Passed number is less than 0: ${num}`);
    if (num > 4294967295)
      throw new Error(`Passed number is more than 2**32: ${num}`);
    if (num !== Math.floor(num))
      throw new Error(`Passed number is not an integer number: ${num}`);
    return num;
  },
  fromNumber: (n) => {
    return DWORDHexString._checkU32(n).toString(16).padStart(8, "0");
  },
  toNumber: (s) => {
    const num = parseInt(s, 16);
    if (isNaN(num))
      throw new Error(`Passed string is not hexadecimal: ${s}`);
    return DWORDHexString._checkU32(num);
  }
};

export {
  Utf8,
  Utf16,
  HexString,
  DWORDHexString,
  StringUtils_exports
};
//# sourceMappingURL=chunk-WCDLHV6S.mjs.map